<div class="experience-courses-catalog-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="courses()"></grid-content>
</div>